import {
  InputGroup,
  Input as ChakraInput,
  type InputProps,
  type InputGroupProps,
} from '@chakra-ui/react';

import type { JSX, RefObject } from 'react';

export interface IInputProps extends InputProps {
  ref?: RefObject<HTMLInputElement | null>;
  containerProps?: Omit<InputGroupProps, 'children'>;
}

export function Input({
  ref,
  containerProps,
  ...rest
}: IInputProps): JSX.Element {
  return (
    <InputGroup {...containerProps}>
      <ChakraInput ref={ref} {...rest} />
    </InputGroup>
  );
}
